import { combineReducers } from 'redux';
import orderBook from './order_book_reducer';
import order from './order_reducer';
import orderTrans from './order_transaction_reducer';
import user from './user_reducer';
import price from './price_reducer';
import setting from './setting_data_reducer';
import login from './login_reducer';
import trans from './transaction_reducer';
import whitelist from './white_list_reducer';
import mobileSettingDataTable from './mobile_setting_data_reducer';
import notify from './notify_reducer';
import commission from './commission_reducer';
import campaign from './campaign_reducer';
import notification from './notification_reducer';

const allReducers = combineReducers({
  orderBook,
  order,
  orderTrans,
  user,
  price,
  setting,
  login,
  trans,
  whitelist,
  mobileSettingDataTable,
  notify,
  commission,
  campaign,
  notification,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state.user = undefined;
    state.notification = undefined;
    state.commission = undefined;
  }

  return allReducers(state, action);
};

export default rootReducer;
